export const BUFF_TOUR_STORAGE_KEY = 'maple-log:buff-tour-seen'

export class BuffTourHistory {
  private seen = false

  constructor(private readonly storage: () => Pick<Storage, 'getItem' | 'setItem'> = () => window.localStorage) {}

  hasSeen(): boolean {
    if (this.seen) return true
    try { return this.storage().getItem(BUFF_TOUR_STORAGE_KEY) === '1' }
    catch { return false }
  }

  markSeen(): void {
    this.seen = true
    try { this.storage().setItem(BUFF_TOUR_STORAGE_KEY, '1') }
    catch { /* Keep the tour dismissed for this page when storage is unavailable. */ }
  }
}

export const buffTourHistory = new BuffTourHistory()
